import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type {
  EligibleSurrenderInquiryDealsParams,
  EligibleSurrenderInquiryDealsResponse,
} from 'src/apis/surrender-service/types';
import type { SurrenderRootRequest } from 'src/apis/surrender-service/use-surrender-root';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  surrenderRoot: SurrenderRootRequest;
  params: EligibleSurrenderInquiryDealsParams | undefined;
};

type ExecuteProps = {
  url: string;
  params: EligibleSurrenderInquiryDealsParams;
};

export function useEligibleSurrenderInquiryDeals({
  surrenderRoot,
  params,
}: HookConfig) {
  const request = useAxios(
    (axios, baseConfig, { url, params }: ExecuteProps) =>
      axios.request<EligibleSurrenderInquiryDealsResponse>({
        ...baseConfig,
        url,
        params,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (
      !surrenderRoot.response?.data._links.getEligibleSurrenderInquiryDeals ||
      !params
    )
      return;

    const templatedUrl =
      surrenderRoot.response.data._links.getEligibleSurrenderInquiryDeals.href;
    const url = urlTemplate.parse(templatedUrl).expand({});

    request.execute({ url, params });
    // oxlint-disable-next-line exhaustive-deps
  }, [surrenderRoot.response]);

  if (
    !surrenderRoot.response?.data._links.getEligibleSurrenderInquiryDeals ||
    !params
  )
    return;

  return request;
}

export type EligibleSurrenderInquiryDealsRequest = ReturnType<
  typeof useEligibleSurrenderInquiryDeals
>;
